import {
    Avatar,
    Divider,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Grid,
    Skeleton
} from '@mui/material';

const NotificationSkeleton = ({ count = 5 }) => {
    return (
        <List
            sx={{
                width: '100%',
                py: 0,
                borderRadius: '10px',
                '& .MuiListItemSecondaryAction-root': {
                    top: 22
                },
                '& .MuiDivider-root': {
                    my: 0
                },
                '& .list-container': {
                    pl: 0
                }
            }}
        >
            {Array.from({ length: count }).map((_, index) => (
                <div key={index}>
                    <ListItem alignItems="center">
                        <ListItemAvatar>
                            <Skeleton variant="circular" width={40} height={40}>
                                <Avatar />
                            </Skeleton>
                        </ListItemAvatar>

                        <ListItemText
                            primary={
                                <Skeleton
                                    variant="text"
                                    width="45%"
                                    height={24}
                                />
                            }
                        />

                        <ListItemSecondaryAction>
                            <Skeleton
                                variant="text"
                                width={90}
                                height={20}
                            />
                        </ListItemSecondaryAction>
                    </ListItem>

                    <Grid container className="mt-1">
                        <Grid item xs={12}>
                            <Skeleton variant="text" width="95%" />
                            <Skeleton variant="text" width="80%" />
                        </Grid>
                    </Grid>

                    <Divider sx={{ mt: 2 }} className='divider' />
                </div>
            ))}
        </List>
    );
};

export default NotificationSkeleton;